import { useCallback } from "react";
import { useSearchParams } from "react-router-dom";

// useSearchParamsState keeps view state (search terms, filters, page
// numbers) in the URL's search params, so a view remounted by Back/Forward
// or a reload renders as it was left - which also gives it the same height
// on the first render, for scroll restoration. An update changes only the
// given params (null removes one) and replaces the current history entry
// instead of adding one.
export function useSearchParamsState(): [
  URLSearchParams,
  (changes: Record<string, string | null>) => void,
] {
  const [searchParams, setSearchParams] = useSearchParams();
  const updateSearchParams = useCallback(
    (changes: Record<string, string | null>) =>
      setSearchParams(
        (currentParams) => {
          const nextParams = new URLSearchParams(currentParams);
          for (const [name, value] of Object.entries(changes)) {
            if (value === null) nextParams.delete(name);
            else nextParams.set(name, value);
          }
          return nextParams;
        },
        { replace: true },
      ),
    [setSearchParams],
  );
  return [searchParams, updateSearchParams];
}
